import { render, staticRenderFns } from "./UserDataCard.vue?vue&type=template&id=a287d406&scoped=true"
import script from "./UserDataCard.vue?vue&type=script&lang=js"
export * from "./UserDataCard.vue?vue&type=script&lang=js"
import style0 from "./UserDataCard.vue?vue&type=style&index=0&id=a287d406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a287d406",
  null
  
)

export default component.exports